/* eslint-disable max-len */
import 'react';

const WarningSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <defs>
            <linearGradient x1="-2.262%" y1="4.342%" x2="82.243%" y2="87.65%" id="icon_warning__c">
                <stop stopColor="#FF6C07" offset="0%" />
                <stop stopColor="#FF9400" offset="100%" />
            </linearGradient>
            <linearGradient x1="48.347%" y1="-20.735%" x2="51.653%" y2="108.562%" id="icon_warning__e">
                <stop stopColor="#FFF" offset="0%" />
                <stop stopColor="#FFE1C2" offset="100%" />
            </linearGradient>
            <filter x="-11.7%" y="-4.8%" width="123.4%" height="133.6%" filterUnits="objectBoundingBox" id="icon_warning__a">
                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 1 0 0 0 0 0.423876822 0 0 0 0 0.0285915919 0 0 0 0.1 0"
                    in="shadowBlurOuter1"
                />
            </filter>
            <filter x="-325%" y="-59.1%" width="750%" height="218.2%" filterUnits="objectBoundingBox" id="icon_warning__d">
                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
            <path
                d="M14.6 4.511l6.808 11.817a3 3 0 01-2.599 4.498H5.191a3 3 0 01-2.6-4.498l6.81-11.817a3 3 0 015.198 0z"
                id="icon_warning__b"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <g>
                <use fill="#000" filter="url(#icon_warning__a)" xlinkHref="#icon_warning__b" />
                <use fill="url(#icon_warning__c)" xlinkHref="#icon_warning__b" />
            </g>
            <g filter="url(#icon_warning__d)" transform="translate(11 7)" fill="url(#icon_warning__e)" fillRule="nonzero">
                <path d="M1 9a1 1 0 110 2 1 1 0 010-2zm0-9a1 1 0 01.993.883L2 1v6a1 1 0 01-1.993.117L0 7V1a1 1 0 011-1z" />
            </g>
        </g>
    </svg>
);

export default WarningSvg;
